module.exports = __webpack_public_path__ + "merriweather-regular-webfont.eb5818c8a044d8eb2e2d.woff";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/merriweather-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/merriweather-regular-webfont.woff
// module chunks = 2